// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__qlJ3L","categories":"HomePage_categories__bJ6rF"};